import { Card } from '@/components/atoms/Card';
import LinkButton from '@/components/molecules/LinkButton';

import AlarmInfoIcon from '@/assets/icons/AlarmInfoIcon.svg?react';
import SmartStoreGuideTopImg from '@/assets/images/SmartstoreLoginGuideTop.png';
import SmartStoreGuideBottomImg from '@/assets/images/SmartstoreLoginGuideBottom.png';
import HeaderLayout from '@/components/layouts/HeaderLayout';
import { CONTENTS } from '@/pages/ExternalRegisterMarketPage';
const SMART_COMMERCE_SOLUTION_URL =
  'https://solution.smartstore.naver.com/ko/solution/10XxRcUYSy4N7fiZ5BYNMh/detail';

const SMART_COMMERCE_SOLUTION_SELLER_PAGE_URL =
  'https://sell.smartstore.naver.com/#/member/auth/management';

const SmartCommerceSolutionGuide = () => {
  const smartStoreConfig = CONTENTS.smartstore;
  return (
    <div className="flex flex-col space-y-[30px]">
      <Card className="w-full p-[30px]">
        <div className="flex justify-between">
          <div>
            <h3 className="text-gr-900 c-t3">
              <span className="mr-[8px] rounded-[4px] bg-red-100 px-[6px] py-[4px] align-bottom text-red-300 c-b4">
                1단계
              </span>
              {smartStoreConfig.topGuide.title}
            </h3>
            <div className="mt-[22px] flex">
              <AlarmInfoIcon />
              <div className="ml-[8px]">
                <h2 className="flex text-gr-900 c-t3">{smartStoreConfig.topGuide.subTitle}</h2>
                <p className="mt-[8px] w-[335px] text-gr-800 c-b2">
                  {smartStoreConfig.topGuide.text}
                </p>
                <div className="mt-[42px]">
                  <LinkButton to={smartStoreConfig.topGuide.link}>
                    {smartStoreConfig.topGuide.buttonText}
                  </LinkButton>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img
              className="h-[227px] w-[375px]"
              src={smartStoreConfig.topGuide.guideImg}
              alt="마켓연동 가이드 이미지"
            />
          </div>
        </div>
      </Card>
      <Card className="w-full p-[30px]">
        <h3 className="text-gr-900 c-t3">
          <span className="mr-[8px] rounded-[4px] bg-red-100 px-[6px] py-[4px] align-bottom text-red-300 c-b4">
            2단계
          </span>
          {smartStoreConfig.bottomGuide.title}
        </h3>
        <div className="mt-[22px] flex">
          <AlarmInfoIcon />
          <div className="ml-[8px]">
            <h2 className="flex text-gr-900 c-t3">{smartStoreConfig.bottomGuide.subTitle}</h2>
            <p className="mt-[8px] text-gr-800 c-b2">{smartStoreConfig.bottomGuide.text}</p>
            <div className="mt-[35px]">
              <LinkButton to={smartStoreConfig.bottomGuide.link}>
                {smartStoreConfig.bottomGuide.buttonText}
              </LinkButton>
            </div>
          </div>
        </div>
        <img
          className="mt-[37px]"
          src={smartStoreConfig.bottomGuide.guideImg}
          alt="마켓연동 가이드 이미지"
        />
      </Card>
    </div>
  );
};

export default SmartCommerceSolutionGuide;
